export { LayeredAvatars } from './LayeredAvatars';
export type { LayeredAvatarsProps } from './LayeredAvatars';
